import { type ErrorMapCtx, setErrorMap, ZodIssueCode, type ZodIssueOptionalMessage } from 'zod'
import { defineNuxtPlugin, useNuxtApp } from '#imports'

export default defineNuxtPlugin(() => {
  const { t } = useNuxtApp().$i18n
  setErrorMap((issue: ZodIssueOptionalMessage, ctx: ErrorMapCtx): { message: string } => {
    // Example custom error mapping
    switch (issue.code) {
      case ZodIssueCode.invalid_type:
        if (issue.received === 'null' || issue.received === 'undefined') {
          return { message: t(`errors.required`) }
        }
        return { message: t(`errors.invalid_type`) }
      case ZodIssueCode.invalid_date:
        return { message: t('errors.invalid_date') }
      case ZodIssueCode.too_small:
        if (issue.minimum === 1) return { message: t('errors.required') }
        return issue.type === 'string'
          ? { message: t('errors.tooShort', { min: Number(issue.minimum) }) }
          : { message: ctx.defaultError }
      case ZodIssueCode.too_big:
        return issue.type === 'string'
          ? { message: t('errors.tooLong', { max: Number(issue.maximum) }) }
          : { message: ctx.defaultError }
      case ZodIssueCode.invalid_string:
        return issue.validation === 'uuid'
          ? { message: t('errors.required') }
          : { message: ctx.defaultError }
      case ZodIssueCode.custom:
        return { message: t('errors.required') }
    }

    return { message: ctx.defaultError }
  })
})
